import { BannerApiService } from '@/core';
import {  BannerTypeValues, CommonStatusValues } from '@/shared';
import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { BannerEntity } from '@repo/types';

@Component({
  selector: 'app-banners',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './banners.component.html',
  styleUrl: './banners.component.scss',
})
export class BannersComponent {
  private readonly bannerApi = inject(BannerApiService);

  table = table({
    itemsFn: this.bannerApi.getAdapter(),
    view: {
      itemName: 'Banner'
    },
    columns: {
      id: { label: 'ID' },
      title: { label: 'Title' },
      image: { label: 'Image', type: 'image', transform: (v) => v.url },
      priority: { label: 'Priority' },
      status: {
        label: 'Status',
        items: CommonStatusValues,
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: BannerEntity) => dialog$.banner({ banner: item }).afterSubmit(),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item) => dialog$.deletePrompt(true).action(() => this.bannerApi.deleteBanner(item.id)),
      },
    ],
    events: {
      add: () => dialog$.banner().afterSubmit(),
    },
  });
}
